import { createContext } from 'react'

import { mapTransactionsData } from 'pages/AiProcessDebugV2/utils'

export const PromptTransactionsContext = createContext<
  ReturnType<typeof mapTransactionsData> | undefined
>(undefined)
